import { render, staticRenderFns } from "./overview-fields-setting.vue?vue&type=template&id=1553101e&scoped=true&"
import script from "./overview-fields-setting.vue?vue&type=script&lang=js&"
export * from "./overview-fields-setting.vue?vue&type=script&lang=js&"
import style0 from "./overview-fields-setting.vue?vue&type=style&index=0&id=1553101e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1553101e",
  null
  
)

export default component.exports